import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteIcon from "@mui/icons-material/Delete";
import Folder from "@mui/icons-material/Folder";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { useTheme } from "@mui/material/styles";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MDBox from "../../components/MDBox";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import Footer from "../../examples/Footer";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import {
  AddSlideCall,
  AddSubTitlesCall,
  AddTitlesCall,
  DeleteSubTitlesCall,
  DeleteTitlesCall,
  EditSubTitlesCall,
  EditTitlesCall,
  GetTitlesCall,
  SwapTitlesCall,
} from "../../redux/api/title.api";
import { getQuizLinkedIdsCall } from "../../redux/api/quizSystem.api";
import { store } from "../../redux/store";
import Chip from "@mui/material/Chip";
import ProfSelector from "components/ProfSelector";

function PresentationTitles() {
  const theme = useTheme();
  const authId = useSelector((state) => state?.auth?.id);
  const role = useSelector((state) => state?.auth?.role);
  const [selectedProfId, setSelectedProfId] = useState("");
  // When admin/university_admin: type = selected prof or self; when prof: type = self
  const slideType = (role === "admin" || role === "university_admin") && selectedProfId
    ? selectedProfId
    : authId;
  const type = slideType;

  const initialItems = useSelector((state) => state?.title?.titles);
  const redux = useSelector((state) => state);

  const [fileRefs, setFileRefs] = useState({}); // store refs by subtitle ID

  const [items, setItems] = useState(initialItems);
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [message, setMessage] = useState("");
  const [lang, setLanguage] = useState("en");
  const [linkedTileIds, setLinkedTileIds] = useState([]);

  const openSuccessSB = () => setSuccessSB(true);
  const openErrorSB = () => setErrorSB(true);

  const navigate = useNavigate();
  const isViewingOtherProf = (role === "admin" || role === "university_admin") && !!selectedProfId;

  const fetchTitles = async () => {
    if (!type) return;
    await GetTitlesCall(lang, type);
  };

  useEffect(() => {
    fetchTitles();
  }, [type, lang]);

  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  useEffect(() => {
    const r = store.getState().auth?.role;
    if (r === "prof" || r === "admin" || r === "university_admin") {
      const params = (r === "admin" || r === "university_admin") && selectedProfId ? { prof_id: selectedProfId } : {};
      getQuizLinkedIdsCall(params)
        .then((res) => {
          const data = res?.data;
          if (data?.tile_ids) setLinkedTileIds(data.tile_ids);
        })
        .catch(() => setLinkedTileIds([]));
    }
  }, [selectedProfId]);

  const handleAddTitle = () => {
    AddTitlesCall({
      title: `New Title ${items?.length + 1}`,
      body: `Description ${items?.length + 1}`,
      lang,
      type,
    });
  };

  const handleAddSubtitle = (itemId) => {
    AddSubTitlesCall({
      title: `New Slide ${items?.length + 1}`,
      body: `Description ${items?.length + 1}`,
      title_id: itemId,
      lang,
      type,
    });
  };

  const handleEdit = (id, newValue, type) => {
    if (type === "MainTitle" || type === "MainBody") {
      const body = {
        id,
        lang,
        type: slideType,
        [type === "MainTitle" ? "title" : "body"]: newValue,
      };
      EditTitlesCall(body);
    } else {
      const body = {
        id,
        lang,
        type: slideType,
        [type === "SubTitle" ? "title" : "body"]: newValue,
      };
      EditSubTitlesCall(body);
    }
  };

  const handleDeleteSubTitle = async (id) => {
    const body = {
      id,
      lang,
      type,
    };
    const confirmation = window.confirm(
      "Are you sure you want to delete this subtitle? All your pins, texts and slide inside this subtitle will be deleted permanently."
    );
    if (confirmation) {
      const res = DeleteSubTitlesCall(body);
      if (res?.status === 400) {
        setMessage(res?.message);
        setTimeout(() => {
          openErrorSB();
        }, 200);
      } else {
        setMessage("The subtitle deleted successfully!");
        setTimeout(() => {
          openSuccessSB();
        }, 200);
      }
    }
  };
  const handleDeleteTitle = async (id) => {
    const body = {
      id,
      lang,
      type,
    };
    const confirmation = window.confirm(
      "Are you sure you want to delete this title and all its subtitles? All your pins, texts and slide inside this subtitle will be deleted permanently."
    );
    if (confirmation) {
      const res = await DeleteTitlesCall(body);
      if (res?.status === 400) {
        setMessage(res?.message);
        setTimeout(() => {
          openErrorSB();
        }, 200);
      } else {
        setMessage("The title deleted successfully!");
        setTimeout(() => {
          openSuccessSB();
        }, 200);
      }
    }
  };

  const handleAddMaterial = async (id) => {
    const res = await AddSlideCall({ title_id: id, lang, type });
    if (!res?.slide?.id) return;
    if (role === "admin" || role === "university_admin") {
      navigate(`/presentationMakerPage/${id}/${lang}`);
    } else {
      navigate(`/presentationMakerPage/${id}`);
    }
  };

  const renderItem = (item, index) => {
    const filteredTitle = item?.titleLocalizations?.filter(
      (e) => e.field == "title"
    );

    const title = filteredTitle?.[0]?.value || "Click to edit the title";
    const url = require("../../assets/images/no-image.jpg");
    return (
      <MDBox
        mb={1}
        p={1.5}
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        bgcolor={theme.palette.background?.card ?? theme.palette.background?.default}
        borderRadius="8px"
      >
        {!isViewingOtherProf && (
          <div
            style={{
              alignContent: "flex-start",
              justifyContent: "flex-start",
              width: "100%",
              display: "flex",
            }}
          >
            {index !== 0 && (
              <ArrowDropUpIcon
                fontSize="large"
                onClick={() => {
                  const body = {
                    current_id: item?.id,
                    goal_id: items?.[index - 1]?.id,
                    lang,
                    type,
                  };
                  SwapTitlesCall(body);
                }}
              />
            )}

            {items?.length !== index + 1 && (
              <ArrowDropDownIcon
                fontSize="large"
                onClick={() => {
                  const body = {
                    current_id: item?.id,
                    goal_id: items?.[index + 1]?.id,
                    lang,
                    type,
                  };
                  SwapTitlesCall(body);
                }}
              />
            )}
          </div>
        )}

        <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
          {isViewingOtherProf ? (
            <MDTypography variant="h6" fontWeight="bold">{title}</MDTypography>
          ) : (
            <EditableTitle
              title={title}
              titleFont={"title"}
              onEdit={(newTitle) => handleEdit(item.id, newTitle, "MainTitle")}
            />
          )}
          {linkedTileIds.includes(item.id) && (
            <Chip size="small" label="Quiz" color="info" onClick={() => navigate("/quiz/titles")} sx={{ cursor: "pointer" }} />
          )}
        </MDBox>

        {!isViewingOtherProf && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              marginTop: 12,
              marginBottom: 12,
            }}
          >
            <MDButton
              color="primary"
              variant="contained"
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: 2,
                boxShadow: (t) => t.shadows[4],
                "&:hover": { boxShadow: (t) => t.shadows[6] },
              }}
              onClick={() => handleAddSubtitle(item.id)}
            >
              + New Presentation
            </MDButton>
            <MDButton
              color="error"
              variant="contained"
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: 2,
                boxShadow: (t) => t.shadows[4],
                "&:hover": { boxShadow: (t) => t.shadows[6] },
              }}
              onClick={() => handleDeleteTitle(item.id)}
            >
              Delete
            </MDButton>
          </div>
        )}

        {item?.subtitles?.length > 0 && (
          <MDBox sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: "20px" }}>
            {item.subtitles.map((subtitle, idx) => {
              const filteredTitle = subtitle?.titleLocalizations?.filter(
                (e) => e.field == "title"
              );

              const title =
                filteredTitle?.[0]?.value || "Click to edit the sub title";

              return (
                <MDBox
                  key={subtitle.id}
                  sx={{ width: 280, minWidth: 260, flex: "0 0 auto" }}
                >
                  <MDBox
                    p={3}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    borderRadius="14px"
                    boxShadow="0 2px 12px rgba(0,0,0,0.08)"
                    sx={{
                      cursor: "pointer",
                      transition: "box-shadow 0.25s ease, transform 0.2s ease, border-color 0.2s ease",
                      border: 1,
                      borderColor: "divider",
                      bgcolor: "background.card",
                      "&:hover": {
                        boxShadow: 2,
                        borderColor: "info.main",
                        transform: "translateY(-2px)",
                      },
                    }}
                    onClick={() => {
                      if (subtitle?.slides?.[0]?.id) {
                        if (role === "admin" || role === "university_admin") {
                          navigate(`/presentationMakerPage/${subtitle.id}/${lang}`);
                        } else {
                          navigate(`/presentationMakerPage/${subtitle.id}`);
                        }
                      } else if (!isViewingOtherProf) {
                        handleAddMaterial(subtitle.id);
                      }
                    }}
                  >
                    {/* ICON CONTAINER */}
                    <MDBox sx={{ zoom: 4, cursor: "pointer" }}>
                      <Folder
                        fontSize="large"
                        sx={{ color: "primary.main", cursor: "pointer", mb: -1.5 }}
                      />
                    </MDBox>
                    {/* TITLE */}
                    <MDBox onClick={(e) => e.stopPropagation()}>
                      <EditableTitle
                        title={title}
                        size={15}
                        titleFont="title"
                        onEdit={(newTitle) =>
                          handleEdit(subtitle.id, newTitle, "SubTitle")
                        }
                      />
                    </MDBox>

                    {/* DELETE BUTTON */}
                    <MDButton
                      color="error"
                      variant="outlined"
                      startIcon={<DeleteIcon />}
                      sx={{
                        mt: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        borderRadius: 2,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteSubTitle(subtitle.id);
                      }}
                    >
                      Delete
                    </MDButton>
                    {/* PRESENTATION OVERLAY ICON */}
                  </MDBox>
                </MDBox>
              );
            })}
          </MDBox>
        )}
      </MDBox>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} mb={2}>
        <ProfSelector value={selectedProfId} onChange={setSelectedProfId} />
        {!isViewingOtherProf && (
          <MDButton
            color="primary"
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 2,
              boxShadow: (t) => t.shadows[4],
              "&:hover": { boxShadow: (t) => t.shadows[6] },
            }}
            onClick={() => handleAddTitle()}
          >
            + New Category
          </MDButton>
        )}
      </MDBox>
      <MDBox py={1} width="100%" px={{ xs: 2, md: 3 }}>
        <Grid container spacing={1}>
          {!isEmpty(items) &&
            items.map((item, index) => (
              <Grid item xs={12} key={item.id}>
                {renderItem(item, index)}
              </Grid>
            ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

const EditableTitle = ({ size = null, title, onEdit, titleFont }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentTitle, setCurrentTitle] = useState(title);
  let fontSize = "1rem";
  let fontWight = 400;

  if (titleFont == "title") {
    fontSize = size || "1.2rem";
    fontWight = "bold";
  }
  const handleBlur = () => {
    setIsEditing(false);
    onEdit(currentTitle);
  };

  return isEditing ? (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <input
        type="text"
        value={currentTitle}
        onChange={(e) => setCurrentTitle(e.target.value)}
        onBlur={handleBlur}
        autoFocus
        style={{
          fontSize,
          fontWight,
          textAlign: "center",
          padding: "5px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          width: "80%",
          marginRight: "10px",
        }}
      />
      <MDButton
        size="small"
        color="success"
        variant="contained"
        sx={{
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 2,
          boxShadow: (t) => t.shadows[4],
        }}
        onClick={() => {
          handleBlur();
          onEdit();
        }}
      >
        <Icon fontSize="medium">check</Icon>
      </MDButton>
    </div>
  ) : (
    <MDTypography
      variant="h6"
      onClick={() => setIsEditing(true)}
      style={{ cursor: "pointer", textAlign: "center", fontSize, fontWight }}
    >
      {title}
    </MDTypography>
  );
};

export default PresentationTitles;
